import { Doughnut } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

// 장루 분포 그래프
const JangruGraph = ({ flexCol, graphData, options, data }) => {
  const { t } = useTranslation();
  return (
    <>
      <p className="flex-none font-extrabold text-[18px] ">{t('Admin_Dashboard_stomaDistribution', '장루 분포')}</p>
      <div className="flex items-end justify-between w-full h-full grow">
        <div
          className="flex aspect-square w-full min-w-[160px] mr-6"
          style={{ maxWidth: flexCol ? "160px" : "240px" }} // flexCol일 경우에 그래프 최대크기는 160px
        >
          <Doughnut data={graphData} options={options} />
        </div>
        <div className="flex flex-col justify-end items-end h-full gap-y-3 text-[#020A1B]">
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#8EA0FF] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_jejunostomy', '공장루')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].type1 })}</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#FFBBBB] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_transverseColostomy', '횡행결장루')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].type2 })}</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#94DBCA] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_descendingColostomy', '하행/구불결장루')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].type3 })}</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#FADD79] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_ascendingColostomy', '상행결장루')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].type4 })}</p>
          </div>
          <div className="flex justify-between w-[171px] text-base leading-[22px]">
            <p className="text-[#F9BC60] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_ileostomy', '회장루')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].type5 })}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default JangruGraph;
